<script>
import {defineComponent} from 'vue'
import headNav from "../components/headNav.vue";
import {getRecord} from "../api/api";
import {mapGetters} from "vuex";

export default defineComponent({
  name: "message",
  components:{
    headNav
  },
  computed:{...mapGetters(['userInfo'])},
  data(){
    return{
      page:1,
      total:null,
      dataList:[],
      items: []
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    getList(){
      getRecord({
        id:this.userInfo.id,
        page:this.page,
        limit:10
      }).then(res => {
        console.log(res)
        this.dataList = res.data.data.data
        this.total = res.data.data.total
        this.items = []
        this.dataList.map(item => {
          if(item.type == 1){
            this.items.push({
              balance: item.balance,
              ChangeAmount: `- $${item.price}`,
              TradingHours: item.create_time
            })
          }else {
            this.items.push({
              balance: item.balance,
              ChangeAmount: `+ $${item.price}`,
              TradingHours: item.create_time
            })
          }

        })
      })
    },
    pageChange(e){
      console.log(e)
      this.page = e
      this.getList()
    },
  }


})
</script>

<template>
  <div>
<!--    <head-nav></head-nav>-->
    <!--    <b-container class="ok" fluid style="margin: 20px 0">-->
    <!--      <b-row>-->
    <!--        <b-col sm="12">-->
    <!--          <b-container>-->
    <!--            <b-row>-->
    <!--              <b-col sm="2"><div class="title">update_time</div></b-col>-->
    <!--              <b-col sm="2"><div class="title">sender</div></b-col>-->
    <!--              <b-col sm="8"><div class="title">message</div></b-col>-->
    <!--            </b-row>-->
    <!--            <b-row class="LineRow">-->
    <!--              <b-col sm="2"><div class="">update_time</div></b-col>-->
    <!--              <b-col sm="2"><div class="">sender</div></b-col>-->
    <!--              <b-col sm="8"><div class="">message</div></b-col>-->
    <!--            </b-row>-->
    <!--          </b-container>-->
    <!--        </b-col>-->
    <!--      </b-row>-->
    <!--    </b-container>-->
    <b-container class="ok" fluid style="margin: 20px 0">
      <b-row>
        <b-col sm="12">
          <b-table striped hover :items="items"></b-table>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row style="margin-bottom: 20px;margin-bottom: 15px">
        <b-col sm="4" offset-sm="4">
          <div>
            <el-pagination
              background
              :page-size='10'
              layout="prev, pager, next"
              @current-change="pageChange"
              :total="total">
            </el-pagination>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
@media screen and (min-width: 900px) {
  .ok>.row{
    margin-left: 200px;
    margin-right: 200px;
  }
}
.title{
  font-weight: bold;
  font-size: 18px;
}
.LineRow{

}
</style>



// WEBPACK FOOTER //
// src/view/records.vue